import { Link, useMatches } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { RouteHandle } from './routeHandle';

/** ルートの handle.crumb を連ねてパンくずを表示する（ポータルでは非表示） */
export function Breadcrumbs() {
  const matches = useMatches();
  const crumbs = matches
    .map((m) => {
      const h = m.handle as RouteHandle | undefined;
      if (!h?.crumb) return null;
      const label = typeof h.crumb === 'function' ? h.crumb(m.params) : h.crumb;
      return { id: m.id, label, to: m.pathname };
    })
    .filter((c): c is { id: string; label: string; to: string } => c !== null)
    // 同じ pathname（index ルート等）の重複を除去
    .filter((c, i, arr) => arr.findIndex((x) => x.to.replace(/\/$/, '') === c.to.replace(/\/$/, '') && x.label === c.label) === i);

  if (crumbs.length <= 1) return null;
  return (
    <nav aria-label="パンくずリスト" className="bs-crumbs">
      <ol>
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={c.id}>
              {last ? (
                <span aria-current="page">{c.label}</span>
              ) : (
                <>
                  <Link to={c.to}>{c.label}</Link>
                  <ChevronRight size={13} aria-hidden className="bs-crumbs__sep" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
